export default __webpack_public_path__ + "static/media/support.5b8d4b11.svg";